import { render, staticRenderFns } from "./BxKuncunInfoList.vue?vue&type=template&id=84fbd9aa&scoped=true&"
import script from "./BxKuncunInfoList.vue?vue&type=script&lang=js&"
export * from "./BxKuncunInfoList.vue?vue&type=script&lang=js&"
import style0 from "./BxKuncunInfoList.vue?vue&type=style&index=0&id=84fbd9aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84fbd9aa",
  null
  
)

export default component.exports